export default __webpack_public_path__ + "static/media/closewise-login-summery.ffd94aed.png";